import { PAGE_ANALYTICS_INFO } from '../page-types'
import type { RouteLocationNormalized } from 'vue-router'

/* ------- MICROFRONT - SHOPPING LIST ------- */

export const listsRoutes = [
  {
    path: '/salesrep-shopping-list',
    name: 'technician-shopping-lists',
    component: () => import('@b2ag/micro-front-shopping-list/app'),
    props: () => {
      return {
        microFrontName: 'shopping-list',
        viewName: `all-tech-lists`,
      }
    },
    meta: {
      analyticsPageInfo: PAGE_ANALYTICS_INFO.TECHNICIAN_SHOPPING_LISTS,
      changeSelectedCustomer: false,
      private: true,
      showSearchBar: true,
      showSelectedCustomer: false,
    },
  },
  {
    path: '/customer-shopping-list/:id',
    name: 'customer-shopping-list-details',
    component: () => import('@b2ag/micro-front-shopping-list/app'),
    props: (route: RouteLocationNormalized) => ({
      microFrontName: 'shopping-list',
      viewName: 'shopping-list-details',
      id: route.params.id,
    }),
    meta: {
      analyticsPageInfo: PAGE_ANALYTICS_INFO.LIST_DETAILS,
      changeSelectedCustomer: false,
      isCustomerProfileRoute: true,
      private: true,
      showSearchBar: true,
      showSelectedCustomer: false,
    },
  },
  {
    path: '/sending-shopping-list/:shoppingListId',
    name: 'send-shopping-list',
    component: () => import('@b2ag/micro-front-shopping-list/app'),
    props: (route: RouteLocationNormalized) => {
      return {
        microFrontName: 'shopping-list',
        viewName: 'sent',
        shoppingListId: route.params.shoppingListId,
      }
    },
    meta: {
      private: true,
      showSelectedCustomer: false,
      changeSelectedCustomer: false,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.SEND_SHOPPING_LIST,
    },
  },
]
